// copied from packages/ui/src/components/FlavorFinder/components/ResultsCardSpec/FlavorFinderResultsCardSpec.tsx
import type { FC } from "react";

import classNames from "classnames";

import styles from "../ResultCard/FlavorFinderResultCard.module.scss";

type FlavorFinderResultCardSpecProps = {
  power: number;
  label: string;
};

const maxDots = 5;

export const FlavorFinderResultCardSpec: FC<FlavorFinderResultCardSpecProps> = ({ power, label }) => {
  return (
    <div className={styles.resultCardSpec}>
      <span className={styles.specTitle}>{label}</span>
      <div className={styles.specPower}>
        <div className={styles.specScale}>
          {[...Array(maxDots).keys()].map((item) => {
            const isFullActive = item < Math.floor(power);
            const isHalfActive = power - item > 0 && power - item < 1;
            return (
              <span
                key={item}
                className={classNames(styles.specDot, {
                  [styles.specDotActive]: isFullActive,
                  [styles.specDotHalf]: isHalfActive,
                })}
              />
            );
          })}
          <span className={styles.specValue}>{power}</span>
        </div>
      </div>
    </div>
  );
};

export default FlavorFinderResultCardSpec;
